import type {ReactElement} from 'react';
import React from 'react';
import {ControlledSlider} from '@Components/controlled-slider';
import {getCurrentPageDuration} from '@Components/poster-editor/poster-editor-reducer';
import {useAppSelector} from '@/hooks';

interface CustomDurationSliderProps {
  className?: string;
}

export function CustomDurationSlider({className = ''}: CustomDurationSliderProps): ReactElement {
  const setCurrentTime = (newValue: number | number[]): void => {
    void window.posterEditor?.whiteboard?.seek(newValue as number);
  };

  const currentPageTime = useAppSelector((state) => {
    return state.posterEditor.currentTime;
  });

  const currentPageDuration = useAppSelector(getCurrentPageDuration);

  return <ControlledSlider className={className} value={currentPageTime} onSlide={setCurrentTime} max={currentPageDuration} step={0.1} handleStyle={{opacity: 0}} />;
}
